import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewInstalarWC = () => import('./index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'instalar_wc',
        name: 'Instalar WC',
        component: ViewInstalarWC,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
